<template>
    <div class="columns-box">
        <h2 class="heading"><a :href="$store.state.hrefPrefix + '/category/news'">{{ $t("MOST_POPULAR") }}</a></h2>
        <div class="most-popular msite-hide">
            <template v-for="(article, index) in articles" :key="article.id">
                <most-popular-article :article="article"></most-popular-article>
                <ad-banner
                    v-if="index === 0 && adBanner"
                    :ad-banner="adBanner"
                    :ad-banners="adBanners"
                ></ad-banner>
            </template>
        </div>

        <div class="columns-box-msite">
            <div class="columns-box-slider">
                <div class="columns-box-item">
                    <template v-for="(article, index) in articles" :key="article.id">
                        <most-popular-article :article="article"></most-popular-article>
                        <ad-banner
                            v-if="index === 0 && adBanner"
                            :ad-banner="adBanner"
                            :ad-banners="adBanners"
                        ></ad-banner>
                    </template>
                </div>
            </div>
        </div>
    </div>
</template>

<script>
import MostPopularArticle from "@/parts/home/MostPopularArticle.vue";
import AdBanner from "@/parts/adBanner.vue";

export default {
    name: "MostPopular",
    components: {AdBanner, MostPopularArticle},
    props: {
        articles: {
            type: Object,
            default: null
        },
        adBanners: {
            type: Array,
            default: () => []
        },
        adBanner: {
            type: Object,
            default: null
        }
    }
}
</script>

<style scoped>

</style>
